export default __webpack_public_path__ + "static/media/innovative-products.91c9e4ee.pdf";